import React, { Component } from 'react';
import { connect } from 'react-redux';
import Paper from 'material-ui/Paper';
import CommunicationChat from 'material-ui/svg-icons/communication/chat';
import CommunicationContacts from 'material-ui/svg-icons/communication/contacts';
import NotificationVoiceChat from 'material-ui/svg-icons/notification/voice-chat';
import {List, ListItem} from 'material-ui/List';
import Divider from 'material-ui/Divider';
import Subheader from 'material-ui/Subheader';
import Avatar from 'material-ui/Avatar';
import {darkBlack, lightBlack} from 'material-ui/styles/colors';
import portrait1 from './images/portrait1.jpg';
import portrait2 from './images/portrait2.jpg';
import portrait3 from './images/portrait3.jpg';
import portrait4 from './images/portrait4.jpg';
import portrait5 from './images/portrait5.jpg';
import './Email.css';

const mapStateToProps = (state) => {
  return {
    fonts: state.fonts,
    fontSize: state.fontSize,
  }
}

class Email extends Component {
  render() {

    const {
      fonts,
    } = this.props;


    const {
      primary,
      secondary
    } = fonts;

    const styles = {
      primaryFont: {
        fontFamily: primary.name,
      },
      darkPrimary: {
        fontFamily: primary.name,
        color: darkBlack
      },
      secondaryFont: {
        fontFamily: secondary.name,
      },
      darkSecondary: {
        fontFamily: secondary.name,
        color: darkBlack
      }
    }

    return (
      <Paper
        zDepth={1}
        className="phone-wrapper">
        <div className="email-header">
          <CommunicationChat className="email-header-icon" />
          <CommunicationContacts className="email-header-icon-highlighted" />
          <NotificationVoiceChat className="email-header-icon" />
        </div>
        <List className="email-preview-list">
          <Subheader>Today</Subheader>
          <ListItem
            leftAvatar={<Avatar src={portrait1} />}
            primaryText={
              <span style={styles.primaryFont}>
                Brunch this weekend?
              </span>
            }
            secondaryText={
              <p>
                <span style={styles.darkSecondary}>Brendan Lim -- </span>
                <span style={styles.secondaryFont}>
                  I&apos;ll be in your neighborhood doing errands this weekend. Do you want to grab brunch?
                </span>
              </p>
            }
            secondaryTextLines={2}
          />
          <Divider inset={true} />
          <ListItem
            leftAvatar={<Avatar src={portrait2} />}
            primaryText={
              <span style={styles.primaryFont}>Summer BBQ&nbsp;&nbsp;<span style={{color: lightBlack}}>4</span></span>
            }
            secondaryText={
              <p>
                <span style={styles.darkSecondary}>to me, Scott, Jennifer</span> --
                <span style={styles.secondaryFont}>
                  Wish I could come, but I&apos;m out of town this weekend.
                </span>
              </p>
            }
            secondaryTextLines={2}
          />
          <Divider inset={true} />
          <ListItem
            leftAvatar={<Avatar src={portrait3} />}
            primaryText={
              <span style={styles.primaryFont}>
                Oui oui
              </span>
            }
            secondaryText={
              <p>
                <span style={styles.darkSecondary}>Grace Ng</span> --
                <span style={styles.secondaryFont}>
                  Do you have Paris recommendations? Have you ever been?
                </span>
              </p>
            }
            secondaryTextLines={2}
          />
          <Divider inset={true} />
          <ListItem
            leftAvatar={<Avatar src={portrait4} />}
            primaryText={
              <span style={styles.primaryFont}>
                Birthday gift
              </span>
            }
            secondaryText={
              <p>
                <span style={styles.darkSecondary}>Kerem Suer</span> --
                <span style={styles.secondaryFont}>
                  Do you have any ideas what we can get Heidi for her birthday? How about a pony?
                </span>
              </p>
            }
            secondaryTextLines={2}
          />
          <Divider inset={true} />
          <ListItem
            leftAvatar={<Avatar src={portrait5} />}
            primaryText={
              <span style={styles.primaryFont}>
                Recipe to try
              </span>
            }
            secondaryText={
              <p>
                <span style={styles.darkSecondary}>Raquel Parrado</span> --
                <span style={styles.secondaryFont}>
                  We should eat this: grated squash. Corn and tomatillo tacos.
                </span>
              </p>
            }
            secondaryTextLines={2}
          />
        </List>
      </Paper>
    )
  }
}

export default Email = connect(mapStateToProps, undefined)(Email);



// WEBPACK FOOTER //
// ./src/components/generator/elements/Email.jsx